import React from 'react';
import { Icons } from '../../../../icons';
import { SelectOption as StyledSelectOption, OptionCheckbox, IconWrapper } from '../Select.styles';
import type {
  SelectAppearance,
  SelectOption as SelectOptionType,
} from '../Select.types';

interface SelectOptionProps {
  option: SelectOptionType;
  isSelected: boolean;
  isDisabled: boolean;
  isMulti: boolean;
  allSelected?: boolean;
  appearance: SelectAppearance;
  onClick: () => void;
}

export const SelectOption: React.FC<SelectOptionProps> = ({
  option,
  isSelected,
  isDisabled,
  isMulti,
  allSelected = false,
  appearance,
  onClick
}) => {
  return (
    <div style={{ position: 'relative' }}>
      <StyledSelectOption
        $isSelected={isSelected}
        $isDisabled={isDisabled}
        $isMulti={isMulti}
        $appearance={appearance}
        onClick={!isDisabled ? onClick : undefined}
        role="option"
        aria-selected={isSelected}
        aria-disabled={isDisabled}
        translate='no'
      >
        {isMulti && (
          <OptionCheckbox
            type="checkbox"
            checked={isSelected && !allSelected}
            onChange={() => { }} // Handled by onClick
            tabIndex={-1}
            disabled={isDisabled}
          />
        )}
        <span translate='no'>{option.label}</span>
      </StyledSelectOption>

      {!isMulti && isSelected && !allSelected && (
        <IconWrapper $appearance={appearance}>
          <Icons name="iconCheck" color="currentColor" />
        </IconWrapper>
      )}
    </div>
  );
};
